import React, { useEffect, useState } from 'react';
import Hero from '../../../components/Hero';
import GamesDescriptionBg from '../../../assets/image/gamesDescriptionBg.png';
import MilkyWayCasino from '../../../components/gamesDescription/MilkyWayCasino';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ApiHandler } from '../../../helper/ApiHandler';
import Loading from '../../../components/Common/Loading';

const MilkyWayCasinoGame = () => {
    const { id } = useParams();
    const [gameDetails, setGameDetails] = useState(null);
    const [loading, setLoading] = useState(true);
    const token = useSelector((state) => state.auth.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchGameDetails = async () => {
            setLoading(true);
            try {
                const response = await ApiHandler('/get_game_list.php', 'POST', { gameID: id, is_platform: "1" }, undefined, dispatch, navigate);
                const gameData = response.data.data[0];
                setGameDetails(gameData);
            } catch (error) {
                console.error('Failed to fetch game details:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchGameDetails();
    }, [id]);

    if (loading) {
        return <Loading />;
    }

    return (
        <>
            <Hero title={gameDetails?.game_name} bgImg={GamesDescriptionBg} backgroundColor='#290A47' />
            <MilkyWayCasino gameDetails={gameDetails} />
        </>
    );
};

export default MilkyWayCasinoGame;
